"use strict";
/*
 * Copyright (C) 2024 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compression = void 0;
/** Data compression. */
var Compression;
(function (Compression) {
    Compression["NONE"] = "";
    Compression["GZIP"] = "gzip";
    Compression["ZLIB"] = "zlib";
    Compression["ZSTD"] = "zstd";
})(Compression || (exports.Compression = Compression = {}));
//# sourceMappingURL=Compression.js.map